import { DatenauswertungReportKonfigurationBemerkung } from './DatenauswertungReportKonfigurationBemerkung';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { i18n } from '../../i18n/i18n';
import * as React from 'react';
import { WActionButton } from '../../core/elements/WActionButton';

interface DatenauswertungReportKonfigurationBemerkungButtonProps extends React.ClassAttributes<any> {
    data: any;
    noLabel?: boolean;
    standort: number;
    styleProps?: React.CSSProperties;
    sub?: string;
    type: string;
}

interface DatenauswertungReportKonfigurationBemerkungButtonState {
   showDialog: boolean;
}

export class DatenauswertungReportKonfigurationBemerkungButton extends
    React.Component<DatenauswertungReportKonfigurationBemerkungButtonProps, DatenauswertungReportKonfigurationBemerkungButtonState> {

    constructor(props: any) {
        super(props);
        this.state = {
           showDialog: false
        };
    }

    render(): JSX.Element[] {
        return [
            <WActionButton
                styleProps={{ padding: '1px 8px', whiteSpace: 'nowrap', ...(this.props.styleProps && this.props.styleProps) }}
                label={i18n('Bemerkung', 'sys')}
                insideText={!this.props.noLabel ? i18n('Bemerkung', 'sys') : null}
                tooltip={this.props.noLabel ? i18n('Bemerkung', 'sys') : null}
                key='config'
                action='comment'
                disabled={this.state.showDialog}
                onAction={() => this.setState({ showDialog: true })}
            />,
            <React.Fragment key='dialog'>
                {this.state.showDialog && this.renderDialog()}
            </React.Fragment>
        ];
    }

    renderDialog(): JSX.Element {
        return (
            <DialogWrapper2
                onAfterClose={() => this.setState({ showDialog: false })}
                title={i18n('Bemerkung für den PDF-Report', 'sys')}
                width={-1}
                height={270}
            >
                <div>
                    <DatenauswertungReportKonfigurationBemerkung
                        data={this.props.data}
                        standort={this.props.standort}
                        type={this.props.type}
                        sub={this.props.sub}
                        onClose={() => this.setState({ showDialog: false })}
                    />
                </div>
            </DialogWrapper2>
        );
    }
}
